import adminApiClient from './apiClient.js';

export const financeiroApi = {
  listExtrato: async (params = {}) => {
    const { data } = await adminApiClient.get('/financeiro/extrato', { params });
    return data;
  },
  listTransacoes: async (params = {}) => {
    const { data } = await adminApiClient.get('/financeiro/transacoes', { params });
    return data;
  },
};

export default financeiroApi;
